import moment from 'moment'

/**
 * 获取传递 （请求）值
 * @param form
 * @returns {*}
 */
export default (form) => {
  let f = {};
  for (let key in form) {
    let item = form[key];

    // if(item.hide){
    //   continue;
    // }

    switch (item.type) {
      /*日期*/
      case 'date':
        let output = 'YYYY-MM-DD';
        if (item.output) {
          output = item.output
        } else if (item.dateType === 'month') {
          output = 'YYYYMM'
        } else if (item.dateType === 'year') {
          output = 'YYYY'
        }
        f[key] = moment(item.value).format(output);
        if(f[key] == 'Invalid date'){
            f[key] = ''
        }
        break;
      /*其他*/
      default :
        f[key] = item.value;
        break;
    }
  }
  return f
}




// WEBPACK FOOTER //
// ./src/components/s-input/getSItem.js